export const getUrlParameterByName = ( name, url = window.location.href ) => { // phpcs:ignore WordPressVIPMinimum.JS.Window.location
	name = name.replace( /[\[\]]/g, '\\$&' );
	const regex = new RegExp( '[?&]' + name + '(=([^&#]*)|&|#|$)' ),
		results = regex.exec( url );
	if ( ! results ) {
		return null;
	}
	if ( ! results[ 2 ] ) {
		return '';
	}
	return decodeURIComponent( results[ 2 ].replace( /\+/g, ' ' ) );
};

export default getUrlParameterByName;
